import { z } from "zod/v4";
import { campSchema, campSignupSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export const camps = {
	list: () => fetchApi(`/camps`, z.array(campSchema)),
	get: (id: string) => fetchApi(`/camps/${id}`, campSchema),
	create: (body: any) =>
		fetchApi(`/camps`, campSchema, { method: "POST", body: JSON.stringify(body) }),
	update: (id: string, body: any) =>
		fetchApi(`/camps/${id}`, campSchema, { method: "PUT", body: JSON.stringify(body) }),
	remove: (id: string) =>
		fetchApi(`/camps/${id}`, z.object({ deleted: z.boolean() }), { method: "DELETE" }),
	signups: (campId: string) => fetchApi(`/camps/${campId}/signups`, z.array(campSignupSchema)),
	createSignup: (campId: string, body: any) =>
		fetchApi(`/camps/${campId}/signups`, campSignupSchema, {
			method: "POST",
			body: JSON.stringify(body),
		}),
	updateSignup: (campId: string, signupId: string, body: any) =>
		fetchApi(`/camps/${campId}/signups/${signupId}`, campSignupSchema, {
			method: "PUT",
			body: JSON.stringify(body),
		}),
	removeSignup: (campId: string, signupId: string) =>
		fetchApi(`/camps/${campId}/signups/${signupId}`, z.object({ deleted: z.boolean() }), {
			method: "DELETE",
		}),
};
